/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { LeadAssignment } from './LeadAssignment';
import {
    LeadAssignmentFromJSON,
    LeadAssignmentFromJSONTyped,
    LeadAssignmentToJSON,
    LeadAssignmentToJSONTyped,
} from './LeadAssignment';

/**
 * 
 * @export
 * @interface SetLeadAssignments200ResponseData
 */
export interface SetLeadAssignments200ResponseData {
    /**
     * 
     */
    assignments: Array<LeadAssignment>;
}

/**
 * Check if a given object implements the SetLeadAssignments200ResponseData interface.
 */
export function instanceOfSetLeadAssignments200ResponseData(value: object): value is SetLeadAssignments200ResponseData {
    if (!('assignments' in value) || value['assignments'] === undefined) return false;
    return true;
}

export function SetLeadAssignments200ResponseDataFromJSON(json: any): SetLeadAssignments200ResponseData {
    return SetLeadAssignments200ResponseDataFromJSONTyped(json, false);
}

export function SetLeadAssignments200ResponseDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): SetLeadAssignments200ResponseData {
    if (json == null) {
        return json;
    }
    return {
        
        'assignments': ((json['assignments'] as Array<any>).map(LeadAssignmentFromJSON)),
    };
}

export function SetLeadAssignments200ResponseDataToJSON(json: any): SetLeadAssignments200ResponseData {
    return SetLeadAssignments200ResponseDataToJSONTyped(json, false);
}

export function SetLeadAssignments200ResponseDataToJSONTyped(value?: SetLeadAssignments200ResponseData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'assignments': ((value['assignments'] as Array<any>).map(LeadAssignmentToJSON)),
    };
}

